import { render } from "./AdminEventLog.vue?vue&type=template&id=0ec73cce"
import script from "./AdminEventLog.vue?vue&type=script&lang=js"
export * from "./AdminEventLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__